import { useTranslation } from "react-i18next";
import AwardIcon from "../../icons/awardIcon";
import ChipIcon from "../../icons/chopIcon";
import NetworkIcon from "../../icons/networkIcon";
import SmileIcon from "../../icons/smileIcon";
import TruckIcon from "../../icons/truckIcon";

const OurAdvantages = () => {
  const { t } = useTranslation();
  return (
    <article className="py-10 bg-white ">
      <div className="w-11/12 mx-auto">
        <h2 className="text-[32px] font-semibold text-mainBlue text-center">
          {t("ourAdvantages")}
        </h2>
        <section className="grid flex-wrap justify-between h-full grid-cols-2 gap-4 my-8 text-center md:grid-cols-3 lg:grid-cols-5">
          <div className="flex flex-col items-center justify-start">
            <span className="block mx-auto w-fit">
              <NetworkIcon />
            </span>
            <h3 className="my-4 text-xl font-bold">{t("secureWarehouses")}</h3>
            <p className="text-mainGray ">{t("europe/turkey")}</p>
          </div>
          <div className="flex flex-col items-center justify-start">
            <span className="block mx-auto w-fit">
              <AwardIcon />
            </span>
            <h3 className="my-4 text-xl font-bold">{t("19Years")}</h3>
          </div>
          <div className="flex flex-col items-center justify-start">
            <span className="block mx-auto w-fit">
              <TruckIcon />
            </span>
            <h3 className="my-4 text-xl font-bold">{t("shipments")}</h3>
            <p className="text-mainGray">{t("completed")}</p>
          </div>
          <div className="flex flex-col items-center justify-start">
            <span className="block mx-auto w-fit">
              <ChipIcon />
            </span>
            <h3 className="my-4 text-xl font-bold">{t("techLogistics")}</h3>

            <p className="text-mainGray ">{t("since 2021")}</p>
          </div>
          <div className="flex flex-col items-center justify-start">
            <span className="mx-auto">
              <SmileIcon />
            </span>
            <h3 className="my-4 text-xl font-bold">{t("highFocus")}</h3>
          </div>
        </section>
      </div>
    </article>
  );
};

export default OurAdvantages;
